import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import PropTypes from "prop-types";
import ArrowRightDark from "../../../../../../images/icon_arrow_right/icon_arrow_right_dark.svg";

const PopupListItem = ({ text, onClick, withNextStep, disabled }) => (
  <Box
    display="flex"
    justifyContent="space-between"
    onClick={(e) => {
      if (onClick) onClick(e);
    }}
    sx={{ cursor: !onClick ? "none" : "cursor" }}
  >
    <Typography
      variant="body2"
      sx={{
        color: disabled ? "text.secondary" : "text.primary",
      }}
    >
      {text}
    </Typography>
    {withNextStep && <img src={ArrowRightDark} alt="arrow-right" />}
  </Box>
);

PopupListItem.propTypes = {
  text: PropTypes.string,
  withNextStep: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

PopupListItem.defaultProps = {
  text: "",
  withNextStep: false,
  onClick: () => null,
  disabled: false,
};

export default PopupListItem;
